module.exports = __webpack_public_path__ + "static/media/prasad-photography.75980de7.png";